<template>
  <section class="block relative z-1">
    




    <div
      class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75"
    >
      <div
        class="absolute top-0 w-full h-full bg-center bg-cover"
        v-bind:style="{ 'background-image': 'url(' + NFT1_img + ')' }"
      >
        <span
          id="blackOverlay"
          class="w-full h-full absolute opacity-75 bg-black"
        ></span>

        <div class="flex flex-wrap">
          <div class="w-full lg:w-12/12 xl:w-10/12 px-8 py-4"></div>
        </div>
      </div>

      <div class="container relative mx-auto">
        <div class="items-center flex flex-wrap">
          <div class="w-full lg:w-8/12 px-4 ml-auto mr-auto text-center">
            <h1 class="text-white text-5xl">
              About the Paper Bonds and the NFTs
            </h1>
            <p class="mt-4 text-lg text-gray-300 text-justify">
              An unclaimed Government Bond in Golden Mettalic Leva. Backed up by
              French, German and English Bank. Issued in the beginning of XX
              century in Europe, each one of them is a unique issue with its own
              number. Manually signed. All bonds come with additional sheets of
              coupon codes. Format: A2 & A3. Will be sent to any part in the
              world in a frame. NFT issue will be sent to the wallet.
            </p>
          </div>
        </div>

        
      </div>
     <div class="custom-shape-divider-bottom-1623866035">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M1200,0H0V120H281.94C572.9,116.24,602.45,3.86,602.45,3.86h0S632,116.24,923,120h277Z" class="shape-fill"></path>
    </svg>
</div>
     
    </div>

    <section class="relative py-20 bg-dark-100">
      <div class="container mx-auto px-4">
        <div class="items-center flex flex-wrap">
          <div class="w-full md:w-4/12 ml-auto mr-auto px-4 mb-4">
            <img
              alt="..."
              class="max-w-full rounded-lg shadow-lg"
              :src="NFT1_img"
            />
          </div>
          <div class="w-full md:w-6/12 ml-auto mr-auto px-4">
            <div class="md:pr-12">
              <h3 class="text-3xl text-white">What are Government Bonds?</h3>
              <p class="mt-4 text-lg leading-relaxed text-white text-justify">
                Government Bonds are issued by governments on order to to raise
                money. By buying a bond, you are becoming a issuer of a loan,
                which is agreed to be paid back on a specific date, and to pay
                up periodic interest. They are generally considered low-risk
                investments. Bonds tend to be less volatile and less risky than
                stocks, and when held to maturity, can offer more stable and
                consistent returns.
                <br />
                As bonds tend not to offer extraordinarily high returns, they
                are particularly vulnerable when inflation rises. Inflation may
                lead to higher interest rates which are harmful to bond prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    
    
    <div
      class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0"
    >
      <div class="flex-auto px-4 lg:px-10 pt-0">
        <div class="flex flex-wrap">
          <div class="w-full px-4">
            <div class="relative w-full">
              <div class="text-center mt-8">
                <div class="justify-center flex flex-wrap">
                  <div class="w-full lg:w-12/12 px-4 -mt-24">
                    <div class="flex flex-wrap">
                      <div class="w-full lg:w-4/12 px-4">
                        <h5 class="text-xl pb-4 text-center text-white">
                          #282,781
                        </h5>

                        <router-link to="#">
                          <div
                            class="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150"
                          >
                            <img
                              alt="..."
                              class="align-middle border-none max-w-full h-auto rounded-lg"
                              :src="NFT1_img"
                            />
                          </div>
                        </router-link>
                      </div>

                      <div class="w-full lg:w-4/12 px-4">
                        <h5 class="text-xl pb-4 text-center text-white">
                          #057,187
                        </h5>
                        <router-link to="#">
                          <div
                            class="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150"
                          >
                            <img
                              alt="..."
                              class="align-middle border-none max-w-full h-auto rounded-lg"
                              :src="NFT2_img"
                            />
                          </div>
                        </router-link>
                      </div>

                      <div class="w-full lg:w-4/12 px-4">
                        <h5 class="text-xl pb-4 text-center text-white">
                          #056,737
                        </h5>
                        <router-link to="#">
                          <div
                            class="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150"
                          >
                            <img
                              alt="..."
                              class="align-middle border-none max-w-full h-auto rounded-lg"
                              :src="NFT3_img"
                            />
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
        <div class="flex flex-wrap">
          <div class="w-full px-4">
            <div class="relative w-full mb-3">
              <div class="text-center mt-8">
                <div class="justify-center flex flex-wrap">
                  <div class="w-full lg:w-4/12 px-4">
                    <h5 class="text-xl pb-4 text-center text-dark">#282,781</h5>

                    <router-link to="#">
                      <div
                        class="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150"
                      >
                        <img
                          alt="..."
                          class="align-middle border-none max-w-full h-auto rounded-lg"
                          :src="NFT1_img"
                        />
                      </div>
                    </router-link>
                  </div>

                  <div class="w-full lg:w-4/12 px-4">
                    <h5 class="text-xl pb-4 text-center text-dark">#057,187</h5>
                    <router-link to="#">
                      <div
                        class="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150"
                      >
                        <img
                          alt="..."
                          class="align-middle border-none max-w-full h-auto rounded-lg"
                          :src="NFT2_img"
                        />
                      </div>
                    </router-link>
                  </div>

                  <div class="w-full lg:w-4/12 px-4">
                    <h5 class="text-xl pb-4 text-center text-dark">#056,737</h5>
                    <router-link to="#">
                      <div
                        class="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150"
                      >
                        <img
                          alt="..."
                          class="align-middle border-none max-w-full h-auto rounded-lg"
                          :src="NFT3_img"
                        />
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import NFT1_img from "@/assets/img/Government_Bond_282781.jpg";
import NFT2_img from "@/assets/img/Government_Bond_057187.png";
import NFT3_img from "@/assets/img/Government_Bond_056737.png";

export default {
  data() {
    return {
      NFT1_img,
      NFT2_img,
      NFT3_img,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {},
};
</script>
